import React from "react";
import * as THREE from "three";
import { createWebGLSafety } from "./webgl-safety.jsx";

export const NIWebGL = createWebGLSafety({ React, THREE });
